import React, { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLogout } from "../logout/Logout";
import { getFromAdminStudent } from "../hooks/useLocalStorage";

const SessionValidate = ({ children, userType }) => {
  const [isTimedOut, setIsTimedOut] = useState(false);
  const navigate = useNavigate();
  const fromAdmin = getFromAdminStudent();

  const { logoutUser } = useLogout();

  // const userType = getUserType();

  const getLoginRoute = () => {
    switch (userType) {
      case "student":
        return "/studentLogin";
      case "admin":
        return "/adminLogin";
      case "superadmin":
        return "/adminLogin";
      default:
        return "/";
    }
  };
  const userLogout = () => {
    logoutUser({
      navigation: () => navigate(getLoginRoute(), { replace: true }),
    });
  };

  const onIdle = async () => {
    setIsTimedOut(true);
    Swal.fire({
      title: "Session Expired",
      text: "Your Session has Expired. Please Log In Again.",
      icon: "error",
      confirmButtonText: "Continue",
      timer: 10000, // Auto-close after 10 seconds
      timerProgressBar: true, // Show progress bar
      willClose: () => {
        Swal.close();
      },
    }).finally(() => {
      userLogout();
    });
  };

  const onActive = () => {
    setIsTimedOut(false);
  };
  useIdleTimer({
    onIdle,
    onActive,
    timeout: fromAdmin ? 5 * 60 * 1000 : 30 * 60 * 1000,
    crossTab: false,
  });
  return <>{children}</>;
};

export default SessionValidate;
